<div>
  <div class="loading">
    <div style="height:30px;margin-top:50px;color:black;margin-bottom:100px;">
      <img src="assets/loading.svg" alt="loading" style="height:28px;width:28px;margin-right:5px;display:inline-block;"><span> Loading...</span>
    </div>    
  </div>
</div>

